import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import FaultLogEditForm from "./FaultLogEditForm";
import CardContainer from "@/components/CardContainer";
import MessageData from "@/components/MessageData";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { Pages } from "@/shared/Constants";

const FaultLogEditPage = () => {
  const [searchParams] = useSearchParams();
  const toastInfo = useSelector((state: RootState) => state.share.toastInfo);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const editItemId = id ? parseInt(id, 10) : undefined;
  const [faultLogId, setFaultLogId] = useState<number | undefined>(editItemId);

  const handleOnCancel = () => {
    // Check if there's browser history to go back to
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(`/${Pages.dashboard}`);
    }
  };

  return (
    <CardContainer title="Fault Log Detail" subTitle={faultLogId ? `ID: ${faultLogId}` : "New Fault Log"}>
      <div className="p-3">
        <MessageData messages={toastInfo}></MessageData>

        <FaultLogEditForm editItemId={faultLogId} setNewFaultLogId={setFaultLogId} onCancel={handleOnCancel} />
      </div>
    </CardContainer>
  );
};

export default FaultLogEditPage;
